import React from "react";
import { Link } from "react-router-dom";
import { driverPagePath } from "./staffpage";

export default function ReservationCoverage({ coverage, driverId, fleetCode }) {
  if (!coverage) return null;
  const rows = coverage.rows || [];
  return (
    <div className="staff-coverage">
      <p className="staff-sentence">{coverage.line}</p>
      {rows.length ? (
        <dl className="staff-facts">
          {rows.map((row) => (
            <React.Fragment key={row.label}>
              <dt>{row.label}</dt>
              <dd>{row.value}</dd>
            </React.Fragment>
          ))}
        </dl>
      ) : null}
      {coverage.driverLink && driverId ? (
        <p>
          <Link to={driverPagePath(driverId, fleetCode, "insurance")}>Open driver insurance</Link>
        </p>
      ) : null}
    </div>
  );
}
